import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-select',
  templateUrl: './select.page.html',
  styleUrls: ['./select.page.scss'],
})
export class SelectPage implements OnInit {

  @Input() company = {
    guid: '',
    name: ''
  }
  @Input() remove_companies = [];
  @Input() selecting_for_company = false;
  @Input() selecting_for_contact = false;
  @Input() in_companies = [];

  @Input() source_header = 'Avaliable';
  @Input() target_header = 'Selected To Add';
  @Input() modal_title = 'Select Companies';

  @Input() selected_companies: any = [];
  companies: any = [];

  roles: any = [];
  client_roles: any = [];

  @Input() selecting_for_team_member = false;
  @Input() team_member_roles: any = [];



  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService) { }

  ngOnInit() {
    console.log(this.in_companies.length);
    this.GetData();
  }

  async Close() {
    this.modalController.dismiss(null);
  }

  async GetData() {
    if (this.selecting_for_company) await this.GetRoles();
    if(this.selecting_for_contact) await this.GetClientRoles();
    if (this.in_companies.length == 0)
      await this.GetCompanies();
    else {
      this.companies = this.in_companies;
      if(this.remove_companies && this.remove_companies.length >= 0) {
        for (let i = 0; i < this.remove_companies.length; i++) {
          let index = this.globalService.GetArrayIndex(this.companies, this.remove_companies[i].guid);
          if (index >= 0) this.companies.splice(index, 1);
        }
      }
    }
      

    if (this.selecting_for_company) this.SetRoles();
    if (this.selecting_for_contact) this.SetClientRoles();

  }

  async GetCompanies() {
    let data: any = await this.apiService.GetCompanies();;
    console.log(data);
    if (data.success) {
      this.companies = data.data;
      //Filter out the companies from the remove list
      if(this.remove_companies && this.remove_companies.length >= 0) {
        for (let i = 0; i < this.remove_companies.length; i++) {
          let index = this.globalService.GetArrayIndex(this.companies, this.remove_companies[i].guid);
          if (index >= 0) this.companies.splice(index, 1);
        }
      }
      
    }
  }

  async GetRoles() {
    let data: any = await this.apiService.get('firms/companies/roles');
    if (data.success) {
      this.roles = data.data;
    }
  }

   async GetClientRoles() {
    let data: any = await this.apiService.GetRoles();
    if (data.success) {
      this.client_roles = data.data;
    }
  }

  async SetRoles() {
    for (let i = 0; i < this.companies.length; i++) {
      this.companies[i].role_guid = this.roles[0].guid;
    }
  }

  async SetClientRoles() {
    for (let i = 0; i < this.companies.length; i++) {
      this.companies[i].role_guid = this.client_roles[0].guid;
    }
  }

  async Finish() {
    this.modalController.dismiss(this.selected_companies);
  }

  async onTeamMemberRoleChange(company: any, newRoleGuid: string) {
    company.team_member_role_guid = newRoleGuid;
    const matchingRole = this.team_member_roles.find(role => role.guid === newRoleGuid);
    company.team_member_role_title = matchingRole ? matchingRole.title : '';
    company.team_member_role_guid = matchingRole ? matchingRole.guid : '';
  }

  onCompanyPicked(event: any) {
    console.log("Company picked", event);
    if (this.selecting_for_team_member && Array.isArray(this.team_member_roles) && this.team_member_roles.length > 0) {
      console.log("ROLES", this.team_member_roles);
      // Find the team member role with the lowest level
      const lowestLevelRole = this.team_member_roles.reduce((prev, curr) => (prev.level < curr.level ? prev : curr));
      this.selected_companies.forEach((company: any) => {
        if (!company.team_member_role_title) {
          company.team_member_role_title = lowestLevelRole.title;
          company.team_member_role_guid = lowestLevelRole.guid;
        }
      });
    }

    if (this.selecting_for_company && Array.isArray(this.roles) && this.roles.length > 0) {
      // Find the company role with the lowest level
      const lowestLevelRole = this.roles.reduce((prev, curr) => (prev.level < curr.level ? prev : curr));
      this.selected_companies.forEach((company: any) => {
        if (!company.role_guid) {
          company.role_guid = lowestLevelRole.guid;
        }
      });
    }
  }


}
